// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-books-js": () => import("./../../../src/pages/books.js" /* webpackChunkName: "component---src-pages-books-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-publishers-js": () => import("./../../../src/pages/publishers.js" /* webpackChunkName: "component---src-pages-publishers-js" */),
  "component---src-templates-lattecat-js": () => import("./../../../src/templates/Lattecat.js" /* webpackChunkName: "component---src-templates-lattecat-js" */),
  "component---src-templates-latteproduct-js": () => import("./../../../src/templates/Latteproduct.js" /* webpackChunkName: "component---src-templates-latteproduct-js" */),
  "component---src-templates-page-js": () => import("./../../../src/templates/Page.js" /* webpackChunkName: "component---src-templates-page-js" */)
}

